import { Charts } from './Charts';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ProductionQuantityWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Charts />
        </ServicesChartsDataProvider>
    );
};

export default ProductionQuantityWrapper;
